import { NodeViewWrapper, NodeViewProps } from "@tiptap/react";
import { InlineCitationChip } from "./CitationChip";

export function CitationNodeView({ node }: NodeViewProps) {
  const { fileId, fileName, pageNumber } = node.attrs;
  return (
    <NodeViewWrapper as="span" className="inline align-baseline">
      <InlineCitationChip
        fileName={fileName}
        sourceFileId={fileId ?? undefined}
        pageNumber={pageNumber ?? undefined}
        showPageNumber={true}
      />
    </NodeViewWrapper>
  );
}
